import { serializeAs, deserializeAs } from 'cerialize';
import { ContactPerson } from './ContactPerson';
import { Machine } from './Machine';
import { Service } from './Service';
export class UserMaster {

     @serializeAs('id')
     @deserializeAs('id')
     private _id: any;

     @serializeAs('code')
     @deserializeAs('code')
     private _code: any;

     @serializeAs('fname')
     @deserializeAs('fname')
     private _fname: string;

     @serializeAs('lname')
     @deserializeAs('lname')
     private _lname: string;

     @serializeAs('mname')
     @deserializeAs('mname')
     private _mname: string;

     @serializeAs('password')
     @deserializeAs('password')
     private _password: string;

     @serializeAs('company_name')
     @deserializeAs('company_name')
     private _company_name: string;

     @serializeAs('display_name')
     @deserializeAs('display_name')
     private _display_name: string;

     @serializeAs('phone')
     @deserializeAs('phone')
     private _phone: string;

     @serializeAs('phone1')
     @deserializeAs('phone1')
     private _phone1: string;

     @serializeAs('userRole')
     @deserializeAs('userRole')
     private _userRole: any;

     @serializeAs('staffRole')
     @deserializeAs('staffRole')
     private _staffRole: any;

     @serializeAs('address')
     @deserializeAs('address')
     private _address: string;

     @serializeAs('city')
     @deserializeAs('city')
     private _city: string;

     @serializeAs('state')
     @deserializeAs('state')
     private _state: string;

     @serializeAs('country')
     @deserializeAs('country')
     private _country: string;

     @serializeAs('zipcode')
     @deserializeAs('zipcode')
     private _zipcode: string;

     @serializeAs('GST')
     @deserializeAs('GST')
     private _GST: string;

     @serializeAs('PAN')
     @deserializeAs('PAN')
     private _PAN: string;

     @serializeAs('contactPersons')
     @deserializeAs('contactPersons')
     private _contactPersons: Array<ContactPerson>;

     @serializeAs('machines')
     @deserializeAs('machines')
     private _machines: Array<Machine>;

     @serializeAs('services')
     @deserializeAs('services')
     private _services: Array<Service>;

     @serializeAs('email_verified_at')
     @deserializeAs('email_verified_at')
     private _email_verified_at: any;

     @serializeAs('token')
     @deserializeAs('token')
     private _token: any;

     @serializeAs('created_at')
     @deserializeAs('created_at')
     private _created_at: any;

     @serializeAs('updated_at')
     @deserializeAs('updated_at')
     private _updated_at: any;

     @serializeAs('totalContacts')
     @deserializeAs('totalContacts')
     private _totalContacts: any;

     @serializeAs('totalMachines')
     @deserializeAs('totalMachines')
     private _totalMachines: any;

     @serializeAs('lat')
     @deserializeAs('lat')
     private _lat: any;

     @serializeAs('lng')
     @deserializeAs('lng')
     private _lng: any;


     @serializeAs('totalAMCExpired')
     @deserializeAs('totalAMCExpired')
     private _totalAMCExpired: any;

     @serializeAs('totalInAMC')
     @deserializeAs('totalInAMC')
     private _totalInAMC: any;

     @serializeAs('totalInWarranty')
     @deserializeAs('totalInWarranty')
     private _totalInWarranty: any;

     @serializeAs('totalWarrantyExpired')
     @deserializeAs('totalWarrantyExpired')
     private _totalWarrantyExpired: any;

     @serializeAs('totalservices')
     @deserializeAs('totalservices')
     private _totalservices: any;

     @serializeAs('disableLoc')
     @deserializeAs('disableLoc')
     private _disableLoc: any;

     @serializeAs('actual_status')
     @deserializeAs('actual_status')
     private _actual_status: any;

     @serializeAs('live_location')
     @deserializeAs('live_location')
     private _live_location: any;

     @serializeAs('inCompleteUser')
     @deserializeAs('inCompleteUser')
     private _inCompleteUser: any;


    /**
     * Getter live_location
     * @return {any}
     */
	public get live_location(): any {
		return this._live_location;
	}

    /**
     * Setter live_location
     * @param {any} value
     */
	public set live_location(value: any) {
		this._live_location = value;
	}
     


    /**
     * Getter actual_status
     * @return {any}
     */
	public get actual_status(): any {
		return this._actual_status;
	}

    /**
     * Setter actual_status
     * @param {any} value
     */
	public set actual_status(value: any) {
		this._actual_status = value;
	}



     /**
      * Getter services
      * @return {Array<Service>}
      */
     public get services(): Array<Service> {
          return this._services;
     }

     /**
      * Setter services
      * @param {Array<Service>} value
      */
     public set services(value: Array<Service>) {
          this._services = value;
     }



     constructor() {
     }


     /**
      * Getter id
      * @return {any}
      */
     public get id(): any {
          return this._id;
     }

     /**
      * Getter fname
      * @return {string}
      */
     public get fname(): string {
          return this._fname;
     }

     /**
      * Getter lname
      * @return {string}
      */
     public get lname(): string {
          return this._lname;
     }

     /**
      * Getter mname
      * @return {string}
      */
     public get mname(): string {
          return this._mname;
     }

     /**
      * Getter company_name
      * @return {string}
      */
     public get company_name(): string {
          return this._company_name;
     }

     /**
      * Getter display_name
      * @return {string}
      */
     public get display_name(): string {
          return this._display_name;
     }

     /**
      * Getter phone
      * @return {string}
      */
     public get phone(): string {
          return this._phone;
     }

     /**
      * Getter phone1
      * @return {string}
      */
     public get phone1(): string {
          return this._phone1;
     }

     /**
      * Getter userRole
      * @return {any}
      */
     public get userRole(): any {
          return this._userRole;
     }

     /**
      * Getter staffRole
      * @return {any}
      */
     public get staffRole(): any {
          return this._staffRole;
     }

     /**
      * Getter address
      * @return {string}
      */
     public get address(): string {
          return this._address;
     }

     /**
      * Getter city
      * @return {string}
      */
     public get city(): string {
          return this._city;
     }

     /**
      * Getter state
      * @return {string}
      */
     public get state(): string {
          return this._state;
     }

     /**
      * Getter country
      * @return {string}
      */
     public get country(): string {
          return this._country;
     }

     /**
      * Getter zipcode
      * @return {string}
      */
     public get zipcode(): string {
          return this._zipcode;
     }

     /**
      * Getter GST
      * @return {string}
      */
     public get GST(): string {
          return this._GST;
     }

     /**
      * Getter PAN
      * @return {string}
      */
     public get PAN(): string {
          return this._PAN;
     }

     /**
      * Getter created_at
      * @return {any}
      */
     public get created_at(): any {
          return this._created_at;
     }

     /**
      * Getter updated_at
      * @return {any}
      */
     public get updated_at(): any {
          return this._updated_at;
     }

     /**
      * Setter id
      * @param {any} value
      */
     public set id(value: any) {
          this._id = value;
     }

     /**
      * Setter fname
      * @param {string} value
      */
     public set fname(value: string) {
          this._fname = value;
     }

     /**
      * Setter lname
      * @param {string} value
      */
     public set lname(value: string) {
          this._lname = value;
     }

     /**
      * Setter mname
      * @param {string} value
      */
     public set mname(value: string) {
          this._mname = value;
     }

     /**
      * Setter company_name
      * @param {string} value
      */
     public set company_name(value: string) {
          this._company_name = value;
     }

     /**
      * Setter display_name
      * @param {string} value
      */
     public set display_name(value: string) {
          this._display_name = value;
     }

     /**
      * Setter phone
      * @param {string} value
      */
     public set phone(value: string) {
          this._phone = value;
     }

     /**
      * Setter phone1
      * @param {string} value
      */
     public set phone1(value: string) {
          this._phone1 = value;
     }

     /**
      * Setter userRole
      * @param {any} value
      */
     public set userRole(value: any) {
          this._userRole = value;
     }

     /**
      * Setter staffRole
      * @param {any} value
      */
     public set staffRole(value: any) {
          this._staffRole = value;
     }

     /**
      * Setter address
      * @param {string} value
      */
     public set address(value: string) {
          this._address = value;
     }

     /**
      * Setter city
      * @param {string} value
      */
     public set city(value: string) {
          this._city = value;
     }

     /**
      * Setter state
      * @param {string} value
      */
     public set state(value: string) {
          this._state = value;
     }

     /**
      * Setter country
      * @param {string} value
      */
     public set country(value: string) {
          this._country = value;
     }

     /**
      * Setter zipcode
      * @param {string} value
      */
     public set zipcode(value: string) {
          this._zipcode = value;
     }

     /**
      * Setter GST
      * @param {string} value
      */
     public set GST(value: string) {
          this._GST = value;
     }

     /**
      * Setter PAN
      * @param {string} value
      */
     public set PAN(value: string) {
          this._PAN = value;
     }

     /**
      * Setter created_at
      * @param {any} value
      */
     public set created_at(value: any) {
          this._created_at = value;
     }

     /**
      * Setter updated_at
      * @param {any} value
      */
     public set updated_at(value: any) {
          this._updated_at = value;
     }


     /**
      * Getter email_verified_at
      * @return {any}
      */
     public get email_verified_at(): any {
          return this._email_verified_at;
     }

     /**
      * Getter token
      * @return {any}
      */
     public get token(): any {
          return this._token;
     }

     /**
      * Setter email_verified_at
      * @param {any} value
      */
     public set email_verified_at(value: any) {
          this._email_verified_at = value;
     }

     /**
      * Setter token
      * @param {any} value
      */
     public set token(value: any) {
          this._token = value;
     }


     /**
      * Getter contactPersons
      * @return {Array<ContactPerson>}
      */
     public get contactPersons(): Array<ContactPerson> {
          return this._contactPersons;
     }

     /**
      * Setter contactPersons
      * @param {Array<ContactPerson>} value
      */
     public set contactPersons(value: Array<ContactPerson>) {
          this._contactPersons = value;
     }

     /**
      * Getter password
      * @return {string}
      */
     public get password(): string {
          return this._password;
     }

     /**
      * Setter password
      * @param {string} value
      */
     public set password(value: string) {
          this._password = value;
     }

     /**
      * Getter totalContacts
      * @return {any}
      */
     public get totalContacts(): any {
          return this._totalContacts;
     }

     /**
      * Setter totalContacts
      * @param {any} value
      */
     public set totalContacts(value: any) {
          this._totalContacts = value;
     }


     /**
      * Getter totalMachines
      * @return {any}
      */
     public get totalMachines(): any {
          return this._totalMachines;
     }

     /**
      * Setter totalMachines
      * @param {any} value
      */
     public set totalMachines(value: any) {
          this._totalMachines = value;
     }

     /**
      * Getter machines
      * @return {Array<Machine>}
      */
     public get machines(): Array<Machine> {
          return this._machines;
     }

     /**
      * Setter machines
      * @param {Array<Machine>} value
      */
     public set machines(value: Array<Machine>) {
          this._machines = value;
     }

     /**
      * Getter lat
      * @return {any}
      */
     public get lat(): any {
          return this._lat;
     }

     /**
      * Getter lng
      * @return {any}
      */
     public get lng(): any {
          return this._lng;
     }

     /**
      * Setter lat
      * @param {any} value
      */
     public set lat(value: any) {
          this._lat = value;
     }

     /**
      * Setter lng
      * @param {any} value
      */
     public set lng(value: any) {
          this._lng = value;
     }


     /**
      * Getter totalAMCExpired
      * @return {any}
      */
     public get totalAMCExpired(): any {
          return this._totalAMCExpired;
     }

     /**
      * Getter totalInAMC
      * @return {any}
      */
     public get totalInAMC(): any {
          return this._totalInAMC;
     }

     /**
      * Getter totalInWarranty
      * @return {any}
      */
     public get totalInWarranty(): any {
          return this._totalInWarranty;
     }

     /**
      * Getter totalWarrantyExpired
      * @return {any}
      */
     public get totalWarrantyExpired(): any {
          return this._totalWarrantyExpired;
     }

     /**
      * Getter totalservices
      * @return {any}
      */
     public get totalservices(): any {
          return this._totalservices;
     }

     /**
      * Setter totalAMCExpired
      * @param {any} value
      */
     public set totalAMCExpired(value: any) {
          this._totalAMCExpired = value;
     }

     /**
      * Setter totalInAMC
      * @param {any} value
      */
     public set totalInAMC(value: any) {
          this._totalInAMC = value;
     }

     /**
      * Setter totalInWarranty
      * @param {any} value
      */
     public set totalInWarranty(value: any) {
          this._totalInWarranty = value;
     }

     /**
      * Setter totalWarrantyExpired
      * @param {any} value
      */
     public set totalWarrantyExpired(value: any) {
          this._totalWarrantyExpired = value;
     }

     /**
      * Setter totalservices
      * @param {any} value
      */
     public set totalservices(value: any) {
          this._totalservices = value;
     }

     /**
      * Getter code
      * @return {any}
      */
     public get code(): any {
          return this._code;
     }

     /**
      * Setter code
      * @param {any} value
      */
     public set code(value: any) {
          this._code = value;
     }

     /**
      * Getter disableLoc
      * @return {any}
      */
     public get disableLoc(): any {
          return this._disableLoc;
     }

      /**
      * Setter disableLoc
      * @param {any} value
      */
      public set disableLoc(value: any) {
          this._disableLoc = value;
     }
     /**
      * Getter disableLoc
      * @return {any}
      */
     public get inCompleteUser(): any {
          return this._inCompleteUser;
     }

      /**
      * Setter inCompleteUser
      * @param {any} value
      */
     public set inCompleteUser(value: any) {
          this._inCompleteUser = value;
     }
  
}
